module.exports = __webpack_public_path__ + "red_stripes.jpg?1b8ebc50bc9792cf411140f95ad7e970";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/images/red_stripes.jpg
// module id = 473
// module chunks = 0